var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 464 464",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m424 0h40v136h-40zm0 0",
    fill: "#b39a7c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m368 104v-32h-224v32c17.671875 0 32 14.328125 32 32s-14.328125 32-32 32v32h224v-32c-17.671875 0-32-14.328125-32-32s14.328125-32 32-32zm0 0",
    fill: "#ffa733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m280 136c0 13.253906-10.746094 24-24 24s-24-10.746094-24-24 10.746094-24 24-24 24 10.746094 24 24zm0 0",
    fill: "#e6e7e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m0 328h40v136h-40zm0 0",
    fill: "#b39a7c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m112 256h224v128h-224zm0 0",
    fill: "#00665a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m144 384h72c8.824219.027344 15.972656 7.175781 16 16v16c-.027344 8.824219-7.175781 15.972656-16 16h-72l-19.28125 19.28125c-3.007812 3.019531-7.09375 4.71875-11.359375 4.71875h-42.71875c-4.265625 0-8.351563-1.699219-11.359375-4.71875l-19.28125-19.28125v-88h26.238281c8.929688-5.511719 19.273438-8.292969 29.761719-8 5.402344-.03125 10.785156.667969 16 2.078125 3.523438.851563 6.933594 2.113281 10.160156 3.761719l10.558594-10.558594c2.992188-2.996094 7.050781-4.679688 11.28125-4.679688s8.289062 1.683594 11.28125 4.679688l9.4375 9.4375c2.996094 2.992188 4.679688 7.050781 4.679688 11.28125s-1.683594 8.289062-4.679688 11.28125zm0 0",
    fill: "#ffead0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m320 80h-72c-8.835938 0-16-7.164062-16-16v-16c.027344-8.824219 7.175781-15.972656 16-16h72l19.28125-19.28125c3.007812-3.019531 7.09375-4.71875 11.359375-4.71875h42.71875c4.265625 0 8.351563 1.699219 11.359375 4.71875l19.28125 19.28125v88h-26.238281c-8.929688 5.511719-19.273438 8.292969-29.761719 8-9.054688.117188-18.011719-1.882812-26.160156-5.839844l-10.558594 10.558594c-2.992188 2.996094-7.050781 4.679688-11.28125 4.679688s-8.289062-1.683594-11.28125-4.679688l-9.4375-9.4375c-2.996094-2.992188-4.679688-7.050781-4.679688-11.28125s1.683594-8.289062 4.679688-11.28125zm0 0",
    fill: "#ffead0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208 336h-16c0 13.253906 10.746094 24 24 24v8h16v-8c13.253906 0 24-10.746094 24-24s-10.746094-24-24-24v-16c4.417969 0 8 3.582031 8 8h16c0-13.253906-10.746094-24-24-24v-8h-16v8c-13.253906 0-24 10.746094-24 24s10.746094 24 24 24v16c-4.417969 0-8-3.582031-8-8zm0-32c0-4.417969 3.582031-8 8-8v16c-4.417969 0-8-3.582031-8-8zm24 24c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 96h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 128h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 160h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 160h16v16h-16zm0 0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m320 304v-16c-8.835938 0-16-7.164062-16-16h-16c0 17.671875 14.328125 32 32 32zm0 0",
    fill: "#e6e7e8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m160 272h-16c0 8.835938-7.164062 16-16 16v16c17.671875 0 32-14.328125 32-32zm0 0",
    fill: "#e6e7e8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m320 352v-16c-17.671875 0-32 14.328125-32 32h16c0-8.835938 7.164062-16 16-16zm0 0",
    fill: "#e6e7e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.7907132bf6b55ef204fea7d13358ddc8.svg";
export { ForwardRef as ReactComponent };